export const deadzone = (value: number, threshold = 0.1) => {
    const deadzoneValue =
        Math.abs(value) < threshold
            ? 0
            : value < 0
              ? value + threshold
              : value - threshold;
    return deadzoneValue * (1 / (1 - threshold));
};
